import React, { Component } from "react";
import { CometChatUnified } from "./../../CometChat";
import { CometChat } from "@cometchat-pro/chat";
import { v4 as uuidv4 } from "uuid";
import LoadingBar from "react-top-loading-bar";
const ref = React.createRef(null);

class Chat extends Component {
  state = {
    isLogeedIn: false,
  };
  componentDidMount = () => {
    ref.current.continuousStart();
    const appID = process.env.REACT_APP_CHATAPP;
    const region = "EU";
    const appSetting = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(region)
      .build();
    CometChat.init(appID, appSetting).then(
      () => {
        console.log("Initialization completed successfully");
        // You can now call login function.
        const authKey = process.env.REACT_APP_CHATKEY;
        const uid = localStorage.getItem("uuid")
          ? localStorage.getItem("uuid")
          : uuidv4();

        if (!localStorage.getItem("uuid")) {
          localStorage.setItem("uuid", uid);
          localStorage.setItem("type", "patient");
        }
        CometChat.login(uid, authKey).then(
          (user) => {
            this.setState({ isLogeedIn: true });
            console.log("Login Successful:", { user });
          },
          (error) => {
            var name = "Patient";

            var user = new CometChat.User(uid);

            user.setName(name);
            user.setAvatar(
              "https://icon-library.com/images/default-profile-icon/default-profile-icon-16.jpg"
            );

            CometChat.createUser(user, authKey).then(
              (user) => {
                console.log("user created", user);
                CometChat.login(uid, authKey).then((user) => {
                  this.setState({ isLogeedIn: true });
                  console.log("Login Successful:", { user });
                });
              },
              (error) => {
                console.log("error", error);
              }
            );
            console.log("Login failed with exception:", { error });
          }
        );
      },
      (error) => {
        console.log("Initialization failed with error:", error);
        // Check the reason for error and take appropriate action.
      }
    );
  };
  render() {
    this.state.isLogeedIn && ref.current.complete();
    return (
      <>
        <LoadingBar color="#621ac0" ref={ref} shadow={true} />
        {this.state.isLogeedIn && <CometChatUnified />}
      </>
    );
  }
}

export default Chat;
